import { VehicleSideQueryResponseType } from '@/common/queries/selections/VehicleSide/VehicleSideQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const VehicleSideFunction = ({
  vehicleType,
}: {
  vehicleType: number;
}): Promise<VehicleSideQueryResponseType[]> => {
  return fetchApi.get('/selection_item/vehicle_side/wop_list/', {
    params: {
      vehicle_type: vehicleType,
    },
  });
};
